import { log, setLastRequestTime } from '../../../Utils';
import axiosInstance from '../../../actions/AxiosInstance';
import api from '../../../actions/EndPoints';
import { sortBy } from 'lodash';
import moment from 'moment';

export async function getAppointmentDetails({ dispatch, apiKey, setLoading, externalGroupId }) {
    try {
        setLoading(true);
        const getApptData = await axiosInstance.get(api.appointmentDetail(externalGroupId), {
            headers: {
                apiKey,
            },
        });
        if (getApptData) {
            const { data } = getApptData;
            // Filter appointments with reschedule link and in Scheduled status
            const rescheduleEligibleAppts = data?.results?.filter(
                (appts) =>
                    appts.invitation &&
                    appts.invitation.reschedulingLink !== '' &&
                    appts.invitation.status === 'Scheduled'
            );
            log(console.log('rescheduleEligibleAppts', rescheduleEligibleAppts));

            // Filter appointments again with endTime in future
            const futureInvitations = rescheduleEligibleAppts?.filter(
                (appts) => moment(appts.endTime) >= moment()
            );
            log(console.log('futureInvitations', futureInvitations));

            // Sort based on created time - to display latest created appointment
            const sortedByCreatedDates =
                futureInvitations && sortBy(futureInvitations, 'created').reverse();
            log(console.log('sortedByCreatedDates', sortedByCreatedDates));

            // Display appointments according to their appointmentType
            const apptsToDisplay =
                sortedByCreatedDates &&
                sortedByCreatedDates.reduce(
                    (accumulator, appointment) =>
                        Object.assign(accumulator, {
                            [appointment.invitation.appointmentType]: appointment,
                        }),
                    {}
                );
            log(console.log('apptsToDisplay', apptsToDisplay));

            if (apptsToDisplay) {
                dispatch({
                    type: 'APPOINTMENT_DATA',
                    invitations: apptsToDisplay,
                    apptDataLoading: false,
                    isLoading: false,
                });
            } else {
                log(console.log('no appt - show default card'));
                dispatch({
                    type: 'APPOINTMENT_DATA',
                    apptDataLoading: false,
                    isLoading: false,
                    invitations: {},
                });
            }
        }
    } catch (err) {
        log(console.log('Appt call err: ', err));
        dispatch({
            type: 'TIME_TRADE_FAILURE',
            apptDataLoading: false,
            isLoading: false,
            invitations: {},
            timeTradeFailure: true,
        });
        window.metricsData.error = 'Timetrade Failure Error'
        throw err;
    }
}

export async function getActiveActions({ dispatch, apiKey }) {
    try {
        const getAction = await axiosInstance.get(api.cwvActionGetAPI, {
            headers: {
                apiKey,
            }
        });

        dispatch({
            type: 'ACTION_SERVICE',
            activeActions: getAction.data
        });
    } catch (error) {
        log(console.log(error))
        throw error;
    }
}

export async function postInvitePartner(email, pin, apikey) {
    try {
        return await axiosInstance.post(
            api.inviteCoClientAPI,
            {
                emailAddress: email,
                invitePinNumber: pin,
            },
            {
                headers: { apikey },
            }
        );

    } catch (error) {
        return error;
    }
}

export async function getRtqData(apiKey, dispatch) {
    try {
        const rtqData = await axiosInstance.get(api.rtqAPI, {
            headers: {
                apikey: apiKey
            }

        });
        if (rtqData.data) {
            dispatch({
                type: 'RTQ_RESPONSE',
                rtqData: rtqData.data
            });
            setLastRequestTime();
        }
        return rtqData?.data ?? [];
    } catch (error) {
        log(console.log('rtq call error: ', error));
        throw error;

    }
}

export async function postRtq(apiKey, payload) {
    try {
        const response = await axiosInstance.post(api.rtqAPI, payload, {
            headers: {
                apikey: `${apiKey}`,
            },
        });
        setLastRequestTime();
        return response.data;
    } catch (error) {
        log(console.log('rtqApi post call error: ', error));
        throw error;
    }
}

export async function putClientPreferences(apiKey, payload) {
    try {
        const reponse = await axiosInstance.put(api.clientPreferencesAPI, payload, {
            headers: {
                apikey: `${apiKey}`,
            },
        });
        setLastRequestTime();
        return reponse.data
    } catch (error) {
        log(console.log('rtqApi post call error: ', error));
        throw error;
    }
}
